// Gemeinsame PLZ→Ort/Land-Auflösung für alle Adressformulare, damit das
// Verhalten überall identisch ist.
//
// Datenquelle: lokaler Datensatz (public/plz-orte.json), der einmalig bei
// Bedarf von unserem eigenen Server geladen wird — KEIN externer Dienst.
// Eine deutsche PLZ kann mehreren Orten zugeordnet sein (z. B. 56368) — daher
// die volle Liste; das Formular bietet sie als Auswahl (datalist) am Ort-Feld an.

export interface PlzResult {
  orte: string[];
  land: string;
}

type PlzMap = Record<string, string[]>;

let mapPromise: Promise<PlzMap | null> | null = null;

function loadMap(): Promise<PlzMap | null> {
  if (!mapPromise) {
    mapPromise = fetch('/plz-orte.json')
      .then((r) => (r.ok ? (r.json() as Promise<PlzMap>) : null))
      .catch(() => null);
  }
  return mapPromise;
}

// Orte zu einer 5-stelligen PLZ (oder null). Lädt den Datensatz beim ersten
// Aufruf und hält ihn im Speicher.
export async function lookupPlz(plz: string): Promise<PlzResult | null> {
  const clean = (plz || '').trim();
  if (!/^\d{5}$/.test(clean)) return null;
  const map = await loadMap();
  const orte = map?.[clean];
  if (!orte || orte.length === 0) return null;
  return { orte, land: 'Deutschland' };
}
